const DistributorSearchCol = [
    {
      id: 'name',
      numeric: false,
      disablePadding: false,
      label: 'Distributor Name',
    },
    {
      id: 'contact_number',
      numeric: false,
      disablePadding: false,
      label: 'Phone',
    },
    {
      id: 'email',
      numeric: false,
      disablePadding: false,
      label: 'Email',
    },
    {
      id: 'state',
      numeric: false,
      disablePadding: false,
      label: 'State',
    },
    {
      id: 'city',
      numeric: false,
      disablePadding: false,
      label: 'City',
    },
    {
      id: 'is_active',
      numeric: false,
      disablePadding: false,
      label: 'Active',
    },
  ];
  
  export default DistributorSearchCol;
  